import PaymentUnavailable from '../../components/PaymentUnavailable';
export default function PaymentRefunded(){return <PaymentUnavailable context="refund route"/>}
